import { useContext } from 'react'
import { throwPlatformError, UIErrorCode } from '../../errors'
import { ComponentPageStateContext } from '../context'

export const useComponentPageState = () => {
  const context = useContext(ComponentPageStateContext)
  if (!context || !context.componentId) {
    throwPlatformError(
      'useComponentPageState must be used within a ComponentPageStateProvider',
      UIErrorCode.CORE_CONTEXT_NOT_FOUND,
    )
  }
  return context
}
